var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FB607F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_813_50398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4668 26.7422H16.5334C16.0916 26.7422 15.7334 27.1004 15.7334 27.5422C15.7334 27.984 16.0916 28.3422 16.5334 28.3422H23.4667C23.9085 28.3422 24.2668 27.984 24.2668 27.5422C24.2668 27.1004 23.9086 26.7422 23.4668 26.7422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4668 24.2188H16.5334C16.0916 24.2188 15.7334 24.5769 15.7334 25.0188C15.7334 25.4606 16.0916 25.8188 16.5334 25.8188H23.4667C23.9085 25.8188 24.2668 25.4606 24.2668 25.0188C24.2668 24.5769 23.9086 24.2188 23.4668 24.2188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1333 14.2768H27.5879V9.6467C27.5879 9.2049 27.2297 8.84668 26.7879 8.84668H13.2121C12.7703 8.84668 12.4121 9.20485 12.4121 9.6467V14.2768H9.86666C8.83737 14.2768 8 15.1142 8 16.1435V24.192C8 25.2213 8.83737 26.0587 9.86666 26.0587H12.4123V30.3531C12.4123 30.7949 12.7704 31.1531 13.2123 31.1531H26.7877C27.2295 31.1531 27.5877 30.7949 27.5877 30.3531V26.0587H30.1333C31.1626 26.0587 32 25.2213 32 24.192V16.1435C32 15.1142 31.1626 14.2768 30.1333 14.2768ZM14.0121 10.4467H25.9879V14.2768H14.0121V10.4467ZM25.9877 29.5531H14.0123C14.0123 29.3967 14.0123 23.2014 14.0123 23.008H25.9878C25.9877 23.2062 25.9877 29.4027 25.9877 29.5531ZM26.7879 18.9744H24.7515C24.3097 18.9744 23.9515 18.6162 23.9515 18.1743C23.9515 17.7325 24.3096 17.3743 24.7515 17.3743H26.7879C27.2297 17.3743 27.5879 17.7325 27.5879 18.1743C27.5879 18.6162 27.2297 18.9744 26.7879 18.9744Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_813_50398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.b9b36d80d1e7d3641c64d2ca2b2e565d.svg";
export { ForwardRef as ReactComponent };